import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogDismiss,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@barfacil/barfacil-ui'
import { AlertCircle } from 'lucide-react'

import { useAuthContext } from '@/contexts/auth-context'

type UnauthorizedDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const UnauthorizedDialog = ({
  open,
  onOpenChange,
}: UnauthorizedDialogProps) => {
  const { logout } = useAuthContext()

  function handleOnConfirm() {
    logout()
    onOpenChange(false)
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="mb-2">
            <AlertCircle className="text-red-500" size={28} />
          </div>

          <AlertDialogTitle>Sem acesso!</AlertDialogTitle>

          <AlertDialogDescription>
            Sua sessão foi encerrada devido à alteração da empresa no Bar Fácil
            ADM. Por favor, faça login novamente
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <Button onClick={handleOnConfirm} variant="secondary">
            Entendido
          </Button>
        </AlertDialogFooter>

        <AlertDialogDismiss
          className="absolute right-6 top-6"
          onClick={handleOnConfirm}
        />
      </AlertDialogContent>
    </AlertDialog>
  )
}

export { UnauthorizedDialog }
